import { Link, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import routes from '@/routes';
import useLanguage, { useApplyLanguage } from '@/hooks/useLanguage';
import styles from './style.module.css';

const NoMatch = () => {
  const error = useRouteError();
  const { lng, localize } = useLanguage();
  const { t } = useTranslation(undefined, { lng });

  useApplyLanguage();

  const {
    statusText,
    message,
    status,
  } = error || {};

  const content = statusText || message;
  const errorStatus = (status === 404) ? '404' : '500';
  const errorMessage = (status === 404) ? t('pages.error.notFound') : t('pages.error.error');

  return (
    <section className="content">
      <div className={styles.main}>
        <div className={styles.info}>
          <h1>{errorStatus}</h1>
          <h2>{t('pages.error.title')}</h2>
          <p>{errorMessage}</p>
          <p className={styles.hidden}>{content}</p>
          <Link to={localize(routes.main.path)}></Link>
        </div>
      </div>
    </section>
  );
};

export default NoMatch;
